import script from "./PaymentInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentInfo.vue?vue&type=script&setup=true&lang=ts"

import "./PaymentInfo.vue?vue&type=style&index=0&id=ee2f00a6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee2f00a6"]])

export default __exports__